import api from "./api";

const userService = {
  //登录
  login(data: any) {
    return api.post("/login", data);
  },
  //退出登录
  logout() {
    return api.delete("/logout");
  },
  //原始密码修改
  changePassword(data: any) {
    return api.put("/password", data);
  },
  //获取用户列表
  getUserList(params: any) {
    return api.get("/users", { params });
  },
  //添加用户
  addUser(data: any) {
    return api.post("/users", data);
  },
  getUserRoles(params: any) {
    ///api/v1/users/{id}/roles
    return api.get(`/users/${params.id}/roles`);
  },
  //修改用户
  updateUser(id: number, data: any) {
    return api.put(`/users/${id}`, data);
  },
  //用户自行修改密码
  updateUserPassword(params: any) {
    return api.put(`/users/${params.id}/password`, params);
  },
  //删除用户
  deleteUser(id: number) {
    return api.delete(`/users/${id}`);
  },
  //查询医生列表
  getDoctorsList(params: any) {
    return api.get("/doctors", { params });
  },
  //同步医生信息
  syncDoctorInfo() {
    return api.post("/doctors/sync");
  },
  //添加医生
  addDoctor(data: any) {
    return api.post("/doctors", data);
  },
  //修改医生
  updateDoctor(id: number, data: any) {
    return api.put(`/doctors`, data);
  },
  //删除医生
  deleteDoctor(id: number) {
    return api.delete(`/doctors/${id}`);
  },
  //获取医生角色列表
  getRolesList(params: any) {
    return api.get("/doctor/roles", { params });
  },
  //新增医生角色
  addRole(data: any) {
    return api.post("/doctor/roles", data);
  },
  //编辑医生角色
  updateDoctorRole(id: number, data: any) {
    return api.put(`/doctor/roles`, data);
  },
  //删除医生角色
  deleteDoctorRole(id: number) {
    return api.delete(`/doctor/roles/${id}`);
  },
  //检查方法列表
  getDictsList(params: any) {
    return api.get("/dicts", { params });
  },
  //新增检查方法
  addDict(data: any) {
    return api.post("/dicts", data);
  },
  //修改检查方法
  updateDict(id: number, data: any) {
    return api.put(`/dicts/${id}`, data);
  },
  //删除检查方法
  deleteDict(id: number) {
    return api.delete(`/dicts/${id}`);
  },
  //获取检查项目列表
  getProjectsList(params: any) {
    return api.get("/projects", { params });
  },
  //新增检查项目
  addProject(data: any) {
    return api.post("/projects", data);
  },
  //更新检查项目
  updateProject(id: number, data: any) {
    return api.put(`/projects`, data);
  },
  //获取设备类型列表
  getDeviceTypeList(params: any) {
    return api.get("/deviceTypes", { params });
  },
  //新增设备类型
  addDeviceType(data: any) {
    return api.post("/deviceTypes", data);
  },
  //修改设备类型
  updateDeviceType(id: number, data: any) {
    return api.put(`/deviceTypes`, data);
  },
  //删除设备类型
  deleteDeviceType(id: number) {
    return api.delete(`/deviceTypes/${id}`);
  },
  //获取评分详情
  getRatingItems(params: any) {
    return api.get(`/projectItems`, { params });
  },
  //删除评分详情
  deleteRatingItem(id: number) {
    return api.delete(`/projectItems/${id}`);
  },
  //修改评分详情
  saveRatingItems(data: any) {
    return api.post(`/projectItems`, data);
  },
  //获取待质控列表
  getEvaluationslList(params: any) {
    return api.get("/evaluations", { params });
  },
  //获取抽样列表
  getExaminationsList(params: any) {
    return api.get("/examinations", { params });
  },
  // 使用对比剂的患者数据（分页）
  getExaminationsPageByContrastAgent(params: any) {
    return api.get("/examinations/pageByContrastAgent", { params });
  },
  //创建抽样任务
  createEvalBatch(data: any) {
    return api.post("/evaluations/batch", data);
  },
  //获取检查详情
  getExaminationDetail(id: any) {
    return api.get(`/examinations/${id}`);
  },
  //质控历史
  getEvaluationHistory(params: any) {
    return api.get("/evaluations", { params });
  },
  //查询质控任务评分规则
  getEvaluationRules(params: any) {
    return api.get("/evaluations/" + params.evaluationId + "/projectItems", { params });
  },
  submitEvaluation(data: any) {
    return api.put("/evaluations/scoreConfirm", data);
  },
  //申请单规范统计
  getApplyStandardStatistics(params: any) {
    return api.get("/statistic/applyStandard", { params });
  },
  //报告质量统计
  getReportQualityStatistics(params: any) {
    return api.get("/statistic/reportQuality", { params });
  },
  //图像质量
  getImageQualityStatistics(params: any) {
    return api.get("/statistic/imageQuality", { params });
  },
  //审核质量
  getAuditQualityStatistics(params: any) {
    return api.get("/statistic/auditQuality", { params });
  },
  //申请单规范明显
  getApplyStandardStatisticsDetail(params: any) {
    return api.get("/statistic/apply/pie", { params });
  },
  //查询扣分明细数据
  getStatisticsItemsDetail(params: any) {
    //statistic/{type}/detailRawPage
    return api.get(`/statistic/${params.type}/detailPage`, { params });
  },
  //报告质量明显
  getReportQualityStatisticsDetail(params: any) {
    return api.get("/statistic/report/pie", { params });
  },
  //图像质量明细
  getImageQualityStatisticsDetail(params: any) {
    return api.get("/statistic/image/pie", { params });
  },
  //审核报告质量明细
  getAuditQualityStatisticsDetail(params: any) {
    return api.get("/statistic/audit/pie", { params });
  },
  //查询个人工作量
  getStatisticsPersonalWorkload(params: any) {
    return api.get("/statistic/assess/workload", { params });
  },
  //查询个人工作质量
  getStatisticsPersonalQuality(params: any) {
    return api.get("/statistic/assess/quality", { params });
  },
  //按设备类型 - 报告质量分页
  getReportQualityPage(params: any) {
    // return api.get("/statistic/reportQualityPage", { params });
    return api.get("/statistic/staff/report/generalPage", { params });
  },
  //按设备类型 - 图像质量分页
  getImageQualityPage(params: any) {
    // return api.get("/statistic/imageQualityPage", { params });
    return api.get("/statistic/staff/image/generalPage", { params });
  },
  //按设备类型 - 审核报告质量分页
  getAuditQualityPage(params: any) {
    // return api.get("/statistic/auditQualityPage", { params });
    return api.get("/statistic/staff/audit/generalPage", { params });
  },
  //获取后台用户角色列表
  getAdminUserRoles(params: any) {
    return api.get("/roles", { params });
  },
  //后去后台用户权限列表
  getAdminUserRole(params: any) {
    return api.get("/permissions", { params });
  },
  //获取AI质控列表
  getAIEvaluationslList(params: any) {
    return api.get("/evaluations/ai/page", { params });
  },
  //获取质控任务详情
  getEvaluationsDetail(id: any) {
    return api.get(`/evaluations/${id}`);
  },
  //获取权限详细信息
  getRoleDetail(id: any) {
    return api.get(`/roles/${id}`);
  },
  //更新角色信息
  updateRole(id: any, data: any) {
    return api.put(`/roles/${id}`, data);
  },
  //新增角色
  addUserRole(data: any) {
    return api.post(`/roles`, data);
  },
  //删除用户校色
  deleteUserRole(id: any) {
    return api.delete(`/roles/${id}`);
  },
  //赋予用户角色
  assignUserRole(id: any, data: any) {
    return api.put(`/users/${id}/roles`, data);
  },
  //查询AI质控详情
  getAIEvaluationDetail(id: any) {
    return api.get(`/evaluations/ai/${id}`);
  },
  //再次请求AI质控
  retryAIEvaluation(id: any) {
    return api.put(`/evaluations/triggerAI/${id}`);
  },
  //查询用户权限
  getUserPermissions(id: any) {
    return api.get(`/users/${id}/permissions`);
  },
  //删除质控历史
  delEvaluationHistory(id: any) {
    return api.post(`/evaluations/${id}/reset`);
  },
  //手动触发AI质控
  triggerAIEvaluation(params: any) {
    return api.post(`/evaluations/triggerAI`, params);
  },
  //查询ai质控结果
  getAIResult(params: any) {
    return api.get(`/evaluations/detailInfo`, { params });
  },
  //获取危急值列表
  getCriticalValueList(params: any) {
    return api.get("/criticalValues", { params });
  },
  //新增危急值
  addCriticalValue(data: any) {
    return api.post("/criticalValues", data);
  },
  //修改危急值
  updateCriticalValue(id: number, data: any) {
    return api.put(`/criticalValues/${id}`, data);
  },
  //删除危急值
  deleteCriticalValue(id: number) {
    return api.delete(`/criticalValues/${id}`);
  },
  //查询危急值详情
  getCriticalValueDetail(id: number) {
    return api.get(`/criticalValues/${id}`);
  },
  //获取危急值统计
  getStatisticsCritalValue(params: any) {
    ///api/v1/statistic/criticalValues/detail
    return api.get("/statistic/criticalValues/detail", { params });
  },
  //导出危急值数据
  exportStatisticsCritalValue(params: any) {
    ///api/v1/export/critical
    //responseType = 'blob'
    return api.get("/export/critical", { params, responseType: "blob" });
  },
  //二进制文件流存为文件
  downloadFile(data: any, fileName: string, type: string) {
    const blob = new Blob([data], { type: type });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  },
  //导出扣分明细
  exportStatisticsItemsDetail(params: any) {
    return api.get(`/statistic/${params.type}/detail/export`, { params, responseType: "blob" });
  },
  //申请单规范统计导出
  exportApplyStandardStatistics(params: any) {
    return api.get("/statistic/applyStandard/export", { params, responseType: "blob" });
  },
  //报告质量统计导出
  exportReportQualityStatistics(params: any) {
    return api.get("/statistic/reportQuality/export", { params, responseType: "blob" });
  },
  //图像质量导出
  exportImageQualityStatistics(params: any) {
    return api.get("/statistic/imageQuality/export", { params, responseType: "blob" });
  },
  //审核质量导出
  exportAuditQualityStatistics(params: any) {
    return api.get("/statistic/auditQuality/export", { params, responseType: "blob" });
  },
  //获取存储策略
  getStoragePolicies(params: any) {
    ///api/v1/storagePolicies
    return api.get("/storagePolicies", { params });
  },
  //新增策略
  addStoragePolicy(data: any) {
    return api.post("/storagePolicies", data);
  },
  //删除测录
  deleteStoragePolicy(id: number) {
    return api.delete(`/storagePolicies/${id}`);
  },
  //编辑策略
  updateStoragePolicy(id: number, data: any) {
    return api.put(`/storagePolicies/${id}`, data);
  },
  //重新拉取影像
  loadImage(params: any) {
    //POST /operation/study/retrieve?studyInstanceUID=xxxxxxxxxx
    const url = `/operation/study/retrieve?studyInstanceUID=${params.studyInstanceUID}`;
    return api.post(url);
  },
  //AI质控补偿
  aiCompensation(data: any) {
    ///api/v1/ai/compensate
    return api.post("/ai/compensate", data);
  },
  //质控检查统计 -作废 2025-03-03
  // getDashboardExaminationData(params: any) {
  //   ///api/v1/statistic/operation/examination
  //   return api.get("/statistic/operation/examination", { params });
  // },
  //质控任务统计 -作废 2025-03-03
  // getDashboardEvaluationData(params: any) {
  //   ///api/v1/statistic/operation/evaluation
  //   return api.get("/statistic/operation/evaluation", { params });
  // },
  //检查当前质控任务质控项目是否可用
  checkProjectIsAvailable(params: any) {
    ///api/v1/evaluations/preCheckTriggerAI， post
    return api.post("/evaluations/preCheckTriggerAI", params);
  },
  //获取质控概览
  getDashboardOverview(params: any) {
    ///api/v1/statistic/statisticMetric
    return api.get("/statistic/statisticMetric", { params });
  },
  //获取质控统计
  getDashboardStatistics(params: any) {
    ///api/v1/statistic/statisticMetricList
    return api.get("/statistic/statisticMetricList", { params });
  },
  //手动触发月度统计任务
  invokeStatisticJob(params: any) {
    return api.post("/statistic/job/invoke", null, { params });
  },
  //新增或更新对比剂类型
  operateContrastMediaItem(data: any) {
    return api.post("/contrastmediums", data);
  },
  //对比剂列表
  requesContrastMediaList(params: any) {
    return api.get("/contrastmediums", { params });
  },
  //删除对比剂分类
  deleteContrastMediaItem(id: any) {
    return api.delete(`/contrastmediums/${id}`);
  },
  //不良反应类型列表
  requestAdverseReactionList(params: any) {
    return api.get("/adverseReactions/types", { params });
  },
  //新增或更新不良反应类型
  operateAdverseReactionItem(data: any) {
    return api.post("/adverseReactions/types", data);
  },
  //删除不良反应类型
  deleteAdverseReactionItem(id: any) {
    return api.delete(`/adverseReactions/types/${id}`);
  },
  //不良反应记录列表
  requestAdverseReactionRecords(params: any) {
    return api.get("/adverseReactions", { params });
  },
  //新增或更新不良反应记录
  operateAdverseReactionRecord(data: any) {
    return api.post("/adverseReactions", data);
  },
  //删除不良反应记录
  deleteAdverseReactionRecord(id: any) {
    return api.delete(`/adverseReactions/${id}`);
  },
  //新增或更新放射剂量系数
  operateDoseRatioRecord(data: any) {
    return api.post("/radiationDosesCoefficients", data);
  },
  //放射剂量系数列表
  requesDoseRatioRecordList(params: any) {
    return api.get("/radiationDosesCoefficients", { params });
  },
  //删除放射剂量系数
  deleteDoseRatioRecord(id: any) {
    return api.delete(`/radiationDosesCoefficients/${id}`);
  },
  //新增或更新放射剂量参考值
  operateDoseReferenceRecord(data: any) {
    return api.post("/radiationDoseReferences", data);
  },
  //放射剂量参考值列表
  requesDoseReferenceRecord(params: any) {
    return api.get("/radiationDoseReferences", { params });
  },
  //删除放射剂量参考值
  deleteDoseReferenceRecord(id: any) {
    return api.delete(`/radiationDoseReferences/${id}`);
  },
  //新增或更新放射报告
  operateRadiationReport(data: any) {
    return api.post("/radiationReports", data);
  },
  //放射报告列表
  requesRadiationReportList(params: any) {
    return api.get("/radiationReports", { params });
  },
  //删除放射报告
  deleteRadiationReport(id: any) {
    return api.delete(`/radiationReports/${id}`);
  },
  //检查数据同步任务补偿
  syncCase(data: any) {
    // /api/v1/operation/syncExam
    return api.post("/operation/syncExam", data);
  },
  //影像数据同步任务补偿
  syncImage(data: any) {
    // /api/v1/operation/retryDownloadImage
    return api.post("/operation/retryDownloadImage", data);
  },
  //检查数据导入
  importExamination(data: any) {
    return api.post("/operation/importExamination", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  //检查数据导出
  exportExamination(data: any) {
    return api.get("/operation/exportExamination", { params: data, responseType: "blob" });
  },
  //获取设备统计数据
  getDeviceStatistics(params: any) {
    // /api/v1/statistic/statisticEquipment
    return api.get("/statistic/statisticEquipment", { params });
  },
  //医生数据初始化
  initDoctor(data: any) {
    return api.post("/operation/initDoctor", data);
  },
  //下载检查数据示例Excel
  downloadExamExcelExample() {
    return api.get("/operation/downloadExamExcelExample", { responseType: "blob" });
  },
  //上传检查数据Excel
  uploadExaminationExcel(data: any) {
    return api.post("/operation/importExcelExamination", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  //上传检查影像zip
  uploadExaminationImage(data: any) {
    return api.post("/operation/importDicom", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  //上传文件到服务器
  uploadFileToServer(file: any) {
    // /api/v1/operation/uploadArtifact
    return api.post("/operation/uploadArtifact", file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  //质控任务采纳
  adoptEvaluation(data: any) {
    // /api/v1/evaluations/includeInScore
    return api.put("/evaluations/includeInScore", data);
  },
  // 202508
  // 查询部位分类
  getBodyPartList(params: any) {
    // /api/v1/examination-part-types
    return api.get("/examination-part-types", { params });
  },
  // 新增部位分类
  addBodyPartItem(data: any) {
    return api.post("/examination-part-types", data);
  },
  // 更新部位分类
  updateBodyPartItem(id: any, data: any) {
    return api.put(`/examination-part-types/${id}`, data);
  },
  // 删除部位分类
  deleteBodyPartItem(id: any) {
    return api.delete(`/examination-part-types/${id}`);
  },
  // 获取检查部位列表
  getExaminationPartList(params: any) {
    return api.get("/examination-parts", { params });
  },
  // 新增检查部位
  addExaminationPart(data: any) {
    return api.post("/examination-parts", data);
  },
  // 更新检查部位
  updateExaminationPart(id: any, data: any) {
    return api.put(`/examination-parts/${id}`, data);
  },
  // 删除检查部位
  deleteExaminationPart(id: any) {
    return api.delete(`/examination-parts/${id}`);
  },
  //设备明细列表
  getDeviceList(params: any) {
    // /api/v1/deviceInformation
    return api.get("/deviceInformation", { params });
  },
  //新增设备
  addDevice(data: any) {
    return api.post("/deviceInformation", data);
  },
  //修改设备
  updateDevice(id: any, data: any) {
    return api.put(`/deviceInformation/${id}`, data);
  },
  //删除设备
  deleteDevice(id: any) {
    return api.delete(`/deviceInformation/${id}`);
  },
  // 2.1 质控月度错误项统计
  getDashboardErrorStatistics(params: any) {
    return api.get("/statistic/statisticEvaluationItem", { params });
  },
  // 质控大盘错误项趋势
  getDashboardErrorTrend(params: any) {
    return api.get("/statistic/statisticEvaluationItemList", { params });
  },
  // 2.2 以人为维度的精细化统计
  getStatisticsByDoctorName(params: any) {
    return api.get(`/statistic/doctor/${params.type}/detailPage`, { params });
  },
  // 人员质控报告 - 指标概览
  getDoctorQualityMetrics(rowType: string, params: any) {
    return api.get(`/statistic/doctor/report/${rowType}/metric`, { params });
  },
  // 人员质控报告 - 指标趋势
  getDoctorQualityMetricTrend(rowType: string, params: any) {
    return api.get(`/statistic/doctor/report/${rowType}/metricList`, { params });
  },
  // 人员质控报告 - 评级指标趋势
  getDoctorQualityLevelTrend(rowType: string, params: any) {
    return api.get(`/statistic/doctor/report/${rowType}/levelMetricList`, { params });
  },
  // 人员质控报告 - 错误项概览
  getDoctorFailItemMetrics(rowType: string, params: any) {
    return api.get(`/statistic/doctor/report/${rowType}/failItemMetric`, { params });
  },
  // 人员质控报告 - 错误项趋势
  getDoctorFailItemTrend(rowType: string, params: any) {
    return api.get(`/statistic/doctor/report/${rowType}/failItemMetricList`, { params });
  },
  // 人员质控报告 - 扣分明细
  getDoctorQualityDetails(rowType: string, params: any) {
    return api.get(`/statistic/doctor/${rowType}/detailPage`, { params });
  },
  // 区域质控获取机构列表
  getHospitalList() {
    return api.get('/hospital/list');
  }
};
export default userService;
